import React, { useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import { Header } from "common/Header";

const ViewContainer = styled.div`
  min-height: 50vh;
  max-height: 90vh;
  &.card {
    height: 100%;
  }
`;

const ContextMenu = ({ Help = null, options = [], refresh, Custom=null }) => {
  const actions = useContext(ActionsContext);
  const sends =
    (...args) =>
    (/*click event*/) =>
      actions.send(...args);
  return (
    <ul className="context-menu header-dropdown">
      {Custom === null ? null : Custom}
      {Help === null ? null : (
        <li>
          <a
            onClick={() => actions.send("open-help")}
            data-toggle="cardloading"
            data-loading-effect="pulse"
            title="Refresh"
          >
            <i className="material-icons">help_outline</i>
          </a>
        </li>
      )}
      {refresh === null ? null : <li>
        <a
          onClick={sends("do-load")}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>}
      {options.length === 0 ? null : (
        <li className="dropdown hidden-to-operators">
          <a
            className="dropdown-toggle"
            data-toggle="dropdown"
            role="button"
            aria-haspopup="true"
            aria-expanded="false"
            title="Options"
          >
            <i className="material-icons">more_vert</i>
          </a>
          <ul className="dropdown-menu pull-right">
            {options.map(({ label, signal }) => (
              <li key={signal}>
                <a onClick={sends(signal)} >
                  {label}...
                </a>
              </li>
            ))}
          </ul>
        </li>
      )}
    </ul>
  );
};
const View = ({
  title,
  subtitle,
  Help = null,
  refresh,
  className = "",
  options = [],
  children,
  bodyPanelLayout="column",
  ContextMenuCustom=null,
  returnView,
}) => (
  <ViewContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div className={`card ${className}`}>
      <Header
        title={title}
        subtitle={subtitle}
        backButton={!!returnView}
        returnUrl={returnView}
        contextMenu={<ContextMenu
            Custom={ContextMenuCustom}
            Help={Help}
            refresh={refresh}
            options={options}
          />}
      />
      <div className={`body flex-panel-${bodyPanelLayout}`}>{children}</div>
    </div>
    {Help === null ? null : <Help />}
  </ViewContainer>
);

export default View;
